import { formSolicitacao } from './states/solicitacao';
export default {
  ['SET_FORM_STEP'](state: any, value: number): void {
    state.dadosForm.currentStep = value;
  },
  ['SET_FORM'](state: any, value: number): void {
    state.dadosForm = value;
  },
  ['SET_DOCUMENTOS_POR_REGRA'](state: any, value: number): void {
    state.documentosPorRegra = value;
  },
  ['SET_DOCUMENTOS_POR_SOLICITACAO'](state: any, value: number): void {
    state.documentacaoPorTipoSolicitacao = value;
  },
  ['SET_FORM_ARQUIVOS'](state: any, novoArquivo: any): void {
    const index = state.formSolicitacao.arquivos.findIndex(
      a => a.tipoDocumento === novoArquivo.tipoDocumento
    );

    if (index !== -1) {
      state.formSolicitacao.arquivos.splice(index, 1, novoArquivo);
    } else {
      state.formSolicitacao.arquivos.push(novoArquivo);
    }
  },
  ['RESET_FORM'](state: any): void {
    state.formSolicitacao = {
      cnpj: null,
      email: null,
      endereco: null,
      nomeEmpresa: null,
      prepostoEmpresa: null,
      telefone: null,
      tipoSolicitacao: null,
      recaptcha: null,
      arquivos: [],
    };
    // state.documentosPorRegra = [];
    state.documentacaoPorTipoSolicitacao = [];
    state.possuiAutorizacaoConsumidorCativo = false;
  },
  ['SET_POSSUI_SOLICITACAO_EM_ANDAMENTO'](state: any, value: boolean): void {
    state.possuiSolicitacaoEmAndamento = value;
  },
  ['SET_RECAPTCHA'](state: any, value: string): void {
    state.recaptcha = value;
  },
  ['SET_POSSUI_AUTORIZACAO_CONSUMIDOR_CATIVO'](state: any, value: boolean): void {
    state.possuiAutorizacaoConsumidorCativo = value;
  },
  ['SET_DADOS_RECUPERADOS_PRE_ANALISE'](state: any, value: any): void {
  state.formSolicitacao = {
    ...state.formSolicitacao,
    email: value.email || null,
    endereco: value.endereco || null,
    nomeEmpresa: value.nomeEmpresa || null,
    prepostoEmpresa: value.prepostoEmpresa || null,
    telefone: value.telefone || null,
    // adicione outros campos conforme necessário
  };
  },
  ['SET_SOLICITACAO_PRE_APROVADA'](state: any, value: any): void {
    state.solicitacaoPreAprovada = value;
  }
};
